import { makeStyles, createStyles } from '@material-ui/core/styles';

const brandStyles = {
  forreston: {
    logo: {
      height: 25
    }
  },
  oakwood: {
    logo: {
      height: 32
    }
  }
};

export default makeStyles((theme) =>
  createStyles({
    header: {
      height: theme.sizes.headerHeight,
      backgroundColor: theme.colors.header__background_primary,
      justifyContent: 'center',
      display: 'block'
    },
    logo: ({ brandName }) => ({
      height: 48,
      marginLeft: 15,
      ...(brandStyles[brandName]?.logo || {})
    }),
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      height: theme.sizes.headerHeight
    },
    searchContainer: {
      width: '100%'
    }
  })
);
